var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsLogout = function SvgIconsLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 2a1 1 0 0 1 .117 1.993L9 4H5a1 1 0 0 0-.993.883L4 5v14a1 1 0 0 0 .883.993L5 20h4a1 1 0 0 1 .117 1.993L9 22H5a3 3 0 0 1-2.995-2.824L2 19V5a3 3 0 0 1 2.824-2.995L5 2h4zm7.613 4.21.094.083 5 5c.036.035.068.073.097.112l.071.11.054.114.035.105.03.148L22 12l-.003.075-.017.126-.03.111-.044.111-.052.098-.074.104-.073.082-5 5a1 1 0 0 1-1.497-1.32l.083-.094L18.585 13H9a1 1 0 0 1-.117-1.993L9 11h9.585l-3.292-3.293a1 1 0 0 1-.083-1.32l.083-.094a1 1 0 0 1 1.32-.083z"
  })));
};
export default SvgIconsLogout;